import { render, staticRenderFns } from "./SentimentResponse.vue?vue&type=template&id=4fc10639&scoped=true&"
import script from "./SentimentResponse.vue?vue&type=script&lang=js&"
export * from "./SentimentResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc10639",
  null
  
)

export default component.exports